var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linear-loader-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }